export const toBool = (input = '') => ['true', '1', 'yes', 'on'].includes(`${input}`.toLowerCase());
